import { Link } from "react-router-dom";
import BookingLookupForm from "@/features/guest-account/components/BookingLookupForm";
import BookingDetailCard from "@/features/guest-account/components/BookingDetailCard";
import { useBookingLookup } from "@/features/guest-account/hooks/useBookingLookup";

export default function BookingLookupPage() {
  const { booking, loading, error, searched, lookup, cancel, reset } =
    useBookingLookup();

  return (
    <div className="min-h-screen bg-metro-cream">
      {/* Header */}
      <div className="border-b border-gray-100 bg-white">
        <div className="container-narrow py-4">
          <Link
            to="/"
            className="font-serif text-xl tracking-widest text-metro-green-950"
          >
            METROPOLIS
          </Link>
        </div>
      </div>

      <div className="container-narrow py-16">
        <div className="mx-auto max-w-xl">
          {/* Heading */}
          <div className="mb-8 text-center">
            <p className="eyebrow mb-3">Manage Your Stay</p>
            <h1 className="font-serif text-3xl text-metro-green-950 mb-2">
              Find Your Booking
            </h1>
            <p className="text-sm text-metro-ink-subtle">
              Enter the email address and booking reference from your
              confirmation to view or manage your booking.
            </p>
          </div>

          {/* Lookup form */}
          {!booking && (
            <div className="rounded-2xl bg-white p-6 shadow-card md:p-8">
              <BookingLookupForm
                onSubmit={lookup}
                loading={loading}
                error={searched ? error : null}
              />
            </div>
          )}

          {/* Booking detail */}
          {booking && (
            <div className="space-y-4">
              <div className="flex items-center justify-between">
                <h2 className="font-serif text-lg text-metro-green-950">
                  Your Booking
                </h2>
                <button
                  type="button"
                  onClick={reset}
                  className="text-xs font-medium text-metro-green-800 underline-offset-2 hover:underline"
                >
                  Look up another booking
                </button>
              </div>
              <div className="rounded-2xl bg-white p-6 shadow-card md:p-8">
                <BookingDetailCard booking={booking} onCancel={cancel} />
              </div>
            </div>
          )}

          {/* Back to site */}
          <div className="mt-8 text-center">
            <Link
              to="/"
              className="text-sm font-medium text-metro-ink-subtle underline-offset-2 hover:underline"
            >
              ← Back to Hotel Metropolis
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}